import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  BenefitActivityDashboardData,
  BenefitActivityDashboardPagination,
  BenefitActivityDashboardPartner,
  BenefitActivityDashboardSummary,
} from "./Types";

type BenefitActivityDashboardStateType = {
  summary: BenefitActivityDashboardSummary | null;
  partners: BenefitActivityDashboardPartner[];
  pagination: BenefitActivityDashboardPagination | null;
  status: {
    loading: boolean;
    error: string | null;
  };
};

const initialState: BenefitActivityDashboardStateType = {
  summary: null,
  partners: [],
  pagination: null,
  status: {
    loading: false,
    error: null,
  },
};

const benefitActivityDashboardSlice = createSlice({
  name: "benefit_activity_dashboard",
  initialState,
  reducers: {
    setBenefitActivityDashboardLoading: (state, action: PayloadAction<boolean>) => {
      state.status.loading = action.payload;
    },
    setBenefitActivityDashboardError: (
      state,
      action: PayloadAction<string | null>
    ) => {
      state.status.error = action.payload;
    },
    setBenefitActivityDashboardData: (
      state,
      action: PayloadAction<BenefitActivityDashboardData>
    ) => {
      state.summary = action.payload.summary;
      state.partners = action.payload.partners;
      state.pagination = action.payload.pagination;
    },
    clearBenefitActivityDashboardData: (state) => {
      state.partners = [];
      state.pagination = null;
    },
  },
});

export const benefitActivityDashboardSliceReducer =
  benefitActivityDashboardSlice.reducer;
export const benefitActivityDashboardSliceAction =
  benefitActivityDashboardSlice.actions;
